<template>
  <div class="purchase-page">
    <div class="purchase-container">
      <div class="title-bg">签字</div>
      <!-- 搜索区域 -->
      <v-card class="search-card">
        <v-card-text>
          <v-row class="justify-center">
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="searchForm.keyword"
                label="关键字搜索"
                persistent-placeholder
                prepend-inner-icon="mdi-magnify"
                variant="outlined"
                hide-details
                density="compact"
                placeholder="采购单号/供应商名称/供应商唯一码"
                clearable
                class="search-input"
              />
            </v-col>
            <v-col cols="12" sm="8" class="d-flex align-center">
              <div style="width: 100%; padding-right: calc(50% - 84px); margin-left: auto; display: flex; gap: 8px;">
                <!-- <v-btn
                  color="primary"
                  prepend-icon="mdi-magnify"
                  variant="tonal"
                  @click="handleSearch"
                  class="search-btn"
                  density="compact"
                  style="width: 80px; height: 32px;"
                >
                  查询
                </v-btn>
                <v-btn
                  color="primary"
                  prepend-icon="mdi-refresh"
                  variant="tonal"
                  @click="handleReset"
                  class="search-btn"
                  density="compact"
                  style="width: 80px; height: 32px;"
                >
                  重置
                </v-btn> -->
                <v-btn
                  color="primary"
                  variant="flat"
                  @click="handleSearch"
                  class="search-btn"
                  density="comfortable"
                >
                  查询
                </v-btn>
                <v-btn
                  color="primary"
                  variant="flat"
                  @click="handleReset"
                  class="search-btn"
                  density="comfortable"
                >
                  重置
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 表格区域 -->
      <v-card class="table-card">
        <v-card-text class="pa-0">
          <v-table class="purchase-table" hover>
            <thead>
              <tr>
                <th v-for="header in headers" :key="header.key" :class="['text-' + header.align]" :style="{ width: header.width }">
                  {{ header.title }}
                  <v-menu v-if="header.key === 'purchaseOrderNo'" v-model="dateFilterMenuOpen" location="bottom" :close-on-content-click="false">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        icon="mdi-filter"
                        variant="text"
                        density="compact"
                        size="small"
                        v-bind="props"
                        :color="searchForm.fromDay !== '' || searchForm.toDay !== '' ? 'primary' : undefined"
                      />
                    </template>
                    <v-card class="filter-menu date-filter-menu">
                      <v-card-text class="pa-3">
                        <div class="date-filter-wrapper">
                          <div class="date-field-wrapper" style="position: relative;">
                            <label class="date-label">开始日期</label>
                            <div class="date-picker-container">
                              <input
                                ref="datePickerFrom"
                                type="date"
                                v-model="searchForm.fromDay"
                                :max="searchForm.toDay || undefined"
                                class="native-date-input"
                                @change="onDatePickerFromChange"
                              />
                              <v-text-field
                                v-model="searchForm.fromDay"
                                placeholder="选择开始日期"
                                variant="outlined"
                                density="compact"
                                hide-details
                                readonly
                                class="date-input-field"
                                prepend-inner-icon="mdi-calendar"
                                @click="openDatePickerFrom"
                              />
                            </div>
                          </div>
                          <div class="date-field-wrapper">
                            <label class="date-label">结束日期</label>
                            <div class="date-picker-container">
                              <input
                                ref="datePickerTo"
                                type="date"
                                v-model="searchForm.toDay"
                                :min="searchForm.fromDay || undefined"
                                class="native-date-input"
                                @change="onDatePickerToChange"
                              />
                              <v-text-field
                                v-model="searchForm.toDay"
                                placeholder="选择结束日期"
                                variant="outlined"
                                density="compact"
                                hide-details
                                readonly
                                class="date-input-field"
                                prepend-inner-icon="mdi-calendar"
                                @click="openDatePickerTo"
                              />
                            </div>
                          </div>
                          <div class="date-filter-actions">
                            <v-btn
                              size="small"
                              color="error"
                              variant="tonal"
                              style="background-color: #453237!important;margin-right: 8px;"
                              @click="clearDateFilter"
                            >
                              清空
                            </v-btn>
                            <v-btn
                              size="small"
                              color="primary"
                              variant="flat"
                              @click="handleSearch"
                            >
                              确定
                            </v-btn>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                  <v-menu v-if="header.key === 'paymentType'" location="bottom">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        icon="mdi-filter"
                        variant="text"
                        density="compact"
                        size="small"
                        v-bind="props"
                        :color="searchForm.paymentType !== null ? 'primary' : undefined"
                      />
                    </template>
                    <v-card class="filter-menu">
                      <v-card-text class="pa-2">
                        <v-radio-group
                          v-model="searchForm.paymentType"
                          density="compact"
                          class="filter-radio-group"
                          hide-details
                        >
                          <v-radio
                            label="全部"
                            :value="null"
                            color="#D2475D"
                            density="compact"
                            @change="handleSearch"
                          />
                          <v-radio
                            v-for="option in paymentMethods"
                            :key="option.value"
                            :label="option.label"
                            :value="option.value"
                            color="#D2475D"
                            density="compact"
                            @change="handleSearch"
                          />
                        </v-radio-group>
                      </v-card-text>
                      <v-divider />
                    </v-card>
                  </v-menu>
                  <v-menu v-if="header.key === 'actions'" location="bottom">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        icon="mdi-filter"
                        variant="text"
                        density="compact"
                        size="small"
                        v-bind="props"
                        :color="searchForm.onlyUnread !== null ? 'primary' : undefined"
                      />
                    </template>
                    <v-card class="filter-menu">
                      <v-card-text class="pa-2">
                        <v-radio-group
                          v-model="searchForm.onlyUnread"
                          density="compact"
                          class="filter-radio-group"
                          hide-details
                        >
                          <v-radio
                            label="全部"
                            :value="null"
                            color="#D2475D"
                            density="compact"
                            @change="handleSearch"
                          />
                          <v-radio
                            v-for="option in onlyUnreadOptions"
                            :key="option.value"
                            :label="option.title"
                            :value="option.value"
                            color="#D2475D"
                            density="compact"
                            @change="handleSearch"
                          />
                        </v-radio-group>
                      </v-card-text>
                      <v-divider />
                    </v-card>
                  </v-menu>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading" class="text-center">
                <td :colspan="headers.length" class="py-8">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <div class="mt-2">加载中...</div>
                </td>
              </tr>
              <tr v-else-if="purchaseList.length === 0" class="text-center">
                <td :colspan="headers.length" class="py-8">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(item, index) in purchaseList" :key="item.id">
                  <td class="text-start" data-key="purchaseOrderNo">
                    <div style="word-break: keep-all!important;">{{ item.purchaseOrderNo }}</div>
                    <div style="color: #898989">{{ formatDate(item.createTime) }}</div>
                  </td>
                  <td class="text-start" data-key="supplierName">
                    <div>{{ item.supplierName || '/' }}</div>
                    <div style="color: #898989">{{ item.supplierNo || '/' }}</div>
                  </td>
                  <td class="text-start">{{ item.paymentCompany || '/' }}</td>
                  <td class="text-center">{{ item.taxRate || 0 }}%</td>
                  <td class="text-center">{{ formatNumber(Number(item.taxAmount)) }}</td>
                  <td class="text-center">{{ formatNumber(Number(item.totalPrice)) }}</td>
                  <td class="text-center">{{ formatNumber(Number(item.totalAmountWithTax)) }}</td>
                  <td class="text-center">
                    <div class="payment-type">{{ getPaymentMethod(item.paymentType).label || '/' }}</div>
                  </td>
                  <td class="text-center">
                    {{ item.purchaseStandard || '/' }}
                  </td>
                  <!-- <td class="text-start" data-key="so">{{ item.so || '/' }}</td> -->
                  <!-- <td class="text-center" data-key="inboundStatus">
                    <div v-if="item.qualityStatus === Number(0)">
                      <img src="@/assets/qualityOff.png" alt="未确认" style="width: 50px;">
                    </div>
                    <div v-else-if="item.qualityStatus === Number(1)">
                      <img src="@/assets/qualityOn.png" alt="已确认" style="width: 50px;">
                    </div>
                    <div v-if="item.warehouseStatus === Number(0)">
                      <img src="@/assets/storageOff.png" alt="未确认" style="width: 50px;">
                    </div>
                    <div v-else-if="item.warehouseStatus === Number(1)">
                      <img src="@/assets/storageOn.png" alt="已确认" style="width: 50px;">
                    </div>
                  </td> -->
                  <td class="text-center">{{ item.warehouseName || '/' }}</td>
                  <td class="text-center">{{ item?.user?.nickname || '/' }}</td>
                  <td class="text-center">
                    <template v-if="item.paidAmount && item.paidRatio">
                      <div v-if="Number(item.paidAmount) !== 0">{{ formatNumber(Number(item.paidAmount)) }}</div>
                      <div v-if="item.paidRatio && Number(item.paidRatio) !== 0">{{ item.paidRatio ? item.paidRatio + '%' : '/' }}</div>
                    </template>
                    <template v-else>
                      <div>/</div>
                    </template>
                  </td>
                  <td class="text-center" data-key="actions">
                    <div class="d-flex justify-center gap-2">
                      <!-- <v-btn
                        class="list-edit-btn"
                        style="margin-right: 8px;"
                        @click="handleEditPurchase(item, index)"
                      >
                        编辑
                      </v-btn> -->
                      <v-btn
                        style="position: relative;"
                        class="list-edit-btn"
                        @click="handlePaymentRecord(item, index)"
                      >
                        查看
                        <div class="red-dot" v-if="item.hasNewPaymentApply"
                          style="width: 8px; height: 8px; background-color: #E34C65; border-radius: 50%;position: absolute; top: -4px; right: -4px;"
                        ></div>
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </v-table>

          <!-- 分页区域 -->
          <div class="custom-pagination d-flex align-center justify-space-between">
            <div class="pagination-info">共 {{ total }} 条记录</div>
            
            <div class="d-flex align-center">
              <!-- <span class="items-per-page-text mr-2">每页项目数</span>
              <v-select
                v-model="pageSize"
                :items="[10, 20, 50, 100]"
                variant="outlined"
                density="compact"
                class="d-inline-flex page-size-select mr-4"
                style="width: 80px;"
                hide-details
                @update:model-value="handlePageSizeChange"
              ></v-select> -->
              
              <v-btn
                icon="mdi-chevron-double-left"
                size="small"
                variant="tonal"
                :disabled="currentPage <= 1 || loading"
                @click="changePage(1)"
                class="pagination-btn"
              ></v-btn>
              
              <v-btn
                icon="mdi-chevron-left"
                size="small"
                variant="tonal"
                :disabled="currentPage <= 1 || loading"
                @click="changePage(currentPage - 1)"
                class="pagination-btn"
              ></v-btn>
              
              <div class="pagination-text mx-4">{{ currentPage }} / {{ totalPages }}</div>
              
              <v-btn
                icon="mdi-chevron-right"
                size="small"
                variant="tonal"
                :disabled="currentPage >= totalPages || loading"
                @click="changePage(currentPage + 1)"
                class="pagination-btn"
              ></v-btn>
              
              <v-btn
                icon="mdi-chevron-double-right"
                size="small"
                variant="tonal"
                :disabled="currentPage >= totalPages || loading"
                @click="changePage(totalPages)"
                class="pagination-btn"
              ></v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <!-- 采购对话框 -->
    <v-dialog
      v-model="showPurchaseDialog"
      max-width="600"
      persistent
    >
      <v-card class="purchase-dialog">
        <v-card-title class="d-flex justify-space-between align-center">
          <span>{{ purchaseData.purchaseOrderNo ? '修改采购' : '发起采购' }}</span>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="closePurchaseDialog"
          />
        </v-card-title>
        <v-card-text>
          <v-form ref="purchaseForm" v-model="purchaseValid">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="purchaseData.vendor.companyName"
                  label="供应商"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  readonly
                  class="v-field--readonly"
                />
              </v-col>
              <!-- :readonly="purchaseData.purchaseOrderNo ? true : false"
              :class="purchaseData.purchaseOrderNo ? 'v-field--readonly' : ''" -->
              <v-col cols="4">
                <v-text-field
                  v-model.number="purchaseData.quantity"
                  label="数量"
                  placeholder="请输入采购数量"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  type="number"
                />
                <!-- :rules="[
                  v => !!v || '请输入数量',
                  v => v > 0 || '数量必须大于0'
                ]" -->
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model.number="purchaseData.price"
                  label="单价"
                  placeholder="请输入采购单价"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  type="number"
                />
                <!-- :rules="[
                  v => v !== null && v !== undefined && v !== '' || '请输入价格',
                  v => v >= 0 || '价格不能为负数'
                ]" -->
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :model-value="calculateTotalPrice(purchaseData.price, purchaseData.quantity)"
                  label="总金额"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  type="number"
                  readonly
                  class="v-field--readonly"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-select
                  v-model="purchaseData.paymentMethod"
                  :items="paymentMethods"
                  label="付款方式"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  item-title="label"
                  item-value="value"
                />
              </v-col>
              <v-col cols="6">
                <div style="position: relative;">
                  <v-text-field
                    v-model="purchaseData.paymentDate"
                    label="计划交货"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    class="native-date-field"
                    @click="openNativeDatePicker"
                  />
                  <!-- 隐藏的原生日期输入框 -->
                  <input
                    ref="nativeDateInput"
                    type="date"
                    v-model="purchaseData.paymentDate"
                    style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px; z-index: 9999;"
                    @change="onNativeDateChange"
                  />
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            color="error"
            variant="tonal"
            style="background-color: #453237!important;"
            @click="closePurchaseDialog"
          >
            取消
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            @click="submitPurchase"
            :loading="purchaseLoading"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, reactive, computed } from 'vue'
import { useRouter } from 'vue-router'
import { purchaseApi } from '@/services/api'
import type { PurchaseListItem } from '@/services/api'
import { useSnackbar } from '@/composables/useSnackbar'
const { showSuccess, showError } = useSnackbar()

const router = useRouter()

const paymentMethods = [
  {value: "0", label: "预付"},
  {value: "1", label: "现付"},
  {value: "2", label: "月结"},
]

// 打开原生日期选择器
const nativeDateInput = ref<HTMLInputElement>()
const datePickerFrom = ref<HTMLInputElement>()
const datePickerTo = ref<HTMLInputElement>()

const openNativeDatePicker = () => {
  if (nativeDateInput.value) {
    // nativeDateInput.value.showPicker?.() || nativeDateInput.value.click()
    try {
      if (nativeDateInput.value.showPicker) {
        nativeDateInput.value.showPicker()
      } else {
        nativeDateInput.value.click()
      }
    } catch (error) {
      console.error('打开日期选择器失败:', error)
    }
  }
}

const openDatePickerFrom = () => {
  const input = datePickerFrom.value
  if (!input) return
  
  try {
    // 优先使用 showPicker API（现代浏览器支持）
    if (input.showPicker) {
      input.showPicker()
    } else {
      // 降级方案：触发 click 事件
      input.click()
      // 备选方案：触发 focus 事件
      input.focus()
    }
  } catch (error) {
    console.error('打开开始日期选择器失败:', error)
    try {
      input.click()
    } catch (e) {
      console.error('降级方案也失败了:', e)
    }
  }
}

const openDatePickerTo = () => {
  const input = datePickerTo.value
  if (!input) return
  
  try {
    // 优先使用 showPicker API（现代浏览器支持）
    if (input.showPicker) {
      input.showPicker()
    } else {
      // 降级方案：触发 click 事件
      input.click()
      // 备选方案：触发 focus 事件
      input.focus()
    }
  } catch (error) {
    console.error('打开结束日期选择器失败:', error)
    try {
      input.click()
    } catch (e) {
      console.error('降级方案也失败了:', e)
    }
  }
}

const clearDateFilter = () => {
  searchForm.fromDay = ''
  searchForm.toDay = ''
  handleSearch()
}

const onDatePickerFromChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  const newDate = target.value
  
  
  try {
    if (newDate && typeof newDate === 'string') {
      // 如果已经选择了结束日期,验证开始日期必须小于结束日期
      if (searchForm.toDay && newDate >= searchForm.toDay) {
        showError('开始日期必须小于结束日期')
        searchForm.fromDay = ''
        target.value = ''
        return
      }
      searchForm.fromDay = newDate
    } else {
      searchForm.fromDay = ''
    }
  } catch (error) {
    console.error('日期处理失败:', error)
    searchForm.fromDay = ''
  }
}

const onDatePickerToChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  const newDate = target.value
  
  try {
    if (newDate && typeof newDate === 'string') {
      // 如果已经选择了开始日期,验证结束日期必须大于开始日期
      if (searchForm.fromDay && newDate < searchForm.fromDay) {
        showError('结束日期必须大于开始日期')
        searchForm.toDay = ''
        target.value = ''
        return
      }
      searchForm.toDay = newDate
      console.log('设置结束日期:', newDate)
    } else {
      searchForm.toDay = ''
      console.log('日期已清空')
    }
  } catch (error) {
    console.error('日期处理失败:', error)
    searchForm.toDay = ''
  }
}

// 原生 HTML5 日期输入框变化处理
const onNativeDateChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  const newDate = target.value
  
  console.log('原生日期输入框变化:', newDate)
  
  try {
    if (newDate && typeof newDate === 'string') {
      // HTML5 date 输入框返回的是 YYYY-MM-DD 格式，直接使用
      purchaseData.value.paymentDate = newDate
      console.log('设置交货时间:', newDate)
    } else {
      purchaseData.value.paymentDate = ''
      console.log('日期已清空')
    }
  } catch (error) {
    console.error('日期处理失败:', error)
    purchaseData.value.paymentDate = ''
  }
  
  console.log('当前表单数据 paymentDate:', purchaseData.value.paymentDate)
}

const getPaymentMethod = (paymentType: string) => {
  let paymentMethod = {
    value: paymentType,
    label: Number(paymentType) === 0 ? '预付' : Number(paymentType) === 1 ? '现付' : Number(paymentType) === 2 ? '月结' : ''
  }
  return paymentMethod
}

// 采购弹窗相关变量
const showPurchaseDialog = ref(false)
const purchaseForm = ref()
const purchaseValid = ref(false)
const purchaseLoading = ref(false)
const vendorList = ref<any[]>([])
const vendorLoading = ref(false)
const vendorSearchText = ref('')
const purchaseData = ref({
  vendor: null as any,
  quantity: null as number | null,
  price: null as number | null,
  purchaseOrderNo: null as string | null,
  paymentMethod: {value: '', label: ''} as any,
  paymentDate: null as string | null,
  id: null as number | null,
})
// 当前编辑的采购订单索引
const currentPurchaseIndex = ref<number>(-1)


// 采购相关方法
// 编辑采购
const handleEditPurchase = (item: any, index: number) => {
  showPurchaseDialog.value = true
  purchaseData.value = {
    vendor: {
      id: item.vendorId,
      companyName: item.supplierName
    },
    quantity: item.quantity,
    price: item.price,
    purchaseOrderNo: item.purchaseOrderNo,
    paymentMethod: getPaymentMethod(item.paymentType),
    paymentDate: formatNYDate(item.schDate),
    id: item.id
  }
  vendorList.value = []
  currentPurchaseIndex.value = index
}

// 关闭采购弹窗
const closePurchaseDialog = () => {
  showPurchaseDialog.value = false
  // purchaseData.value = {
  //   vendor: null,
  //   quantity: null,
  //   price: null,
  //   purchaseOrderNo: null,
  //   paymentMethod: null,
  //   paymentDate: null,
  //   id: null
  // }
  currentPurchaseIndex.value = -1
  vendorSearchText.value = ''
  purchaseForm.value?.reset()
}

// 提交采购
const submitPurchase = async () => {
  if(!purchaseData.value.vendor) {
    showError('请选择供应商')
    return
  }
  if (!purchaseData.value.quantity) {
    showError('请输入数量')
    return
  }
  console.log('purchaseData', purchaseData.value)
  try {
    purchaseLoading.value = true
    const submitData = {
      id: purchaseData.value.id && purchaseData.value.id != null ? purchaseData.value.id : null,
      vendorId: purchaseData.value.vendor?.id,
      quantity: purchaseData.value.quantity,
      price: purchaseData.value.price,
      contractId: purchaseList.value[currentPurchaseIndex.value].productOrderId,
      materialCode: purchaseList.value[currentPurchaseIndex.value].goodsNo,
      schDate: dateTimestamp(purchaseData.value.paymentDate),
      paymentType: typeof(purchaseData.value.paymentMethod) === 'string' ? purchaseData.value.paymentMethod : purchaseData.value.paymentMethod.value
    }
    const res = await purchaseApi.purchaseInitiate(submitData)
    if (res?.code === 0) {
      showSuccess(purchaseData.value.id ? '采购单修改成功' : '采购单创建成功')
      console.log('采购数据:', submitData)
      // let newPurchaseOrder = {
      //   id: res.data.id,
      //   createTime: res.data.createTime,
      //   purchaseOrderNo: res.data.purchaseOrderNo,
      //   supplierName: res.data.supplierName,
      //   guardStatus: res.data.guardStatus,
      //   warehouseStatus: res.data.warehouseStatus,
      //   qualityStatus: res.data.qualityStatus,
      //   vendorId: res.data.vendorId,
      //   quantity: purchaseData.value.quantity,
      //   price: purchaseData.value.price,
      //   schDate: purchaseData.value.paymentDate,
      //   paymentType: purchaseData.value.paymentMethod
      // }
      // console.log('newPurchaseOrder', newPurchaseOrder,currentPurchaseIndex.value)
      // purchaseList.value[currentPurchaseIndex.value] = newPurchaseOrder
      loadPurchaseList()
      closePurchaseDialog()
    } else {
      showError(res?.message)
    }
    // 刷新采购列表
    // await loadPurchaseList()
    
  } catch (error: any) {
    console.error('创建采购单失败:', error)
    showError(error.message || '创建采购单失败')
  } finally {
    purchaseLoading.value = false
  }
}

// 加载供应商列表
const loadVendorList = async () => {
  if(vendorSearchText.value === '' || vendorSearchText.value === null){
    return
  }
  try {
    vendorLoading.value = true
    const res = await purchaseApi.vendorList({
      page: 1,
      pageSize: 100,
      name: vendorSearchText.value || ''
    })
    if (res?.code === 0 && res.data) {
      vendorList.value = res.data.records
      console.log('vendorList', vendorList.value)
    }
  } catch (error: any) {
    console.error('加载供应商列表失败:', error)
    showError(error.message || '加载供应商列表失败')
  } finally {
    vendorLoading.value = false
  }
}

const calculateTotalPrice = (price: number, quantity: number) => {
  return Number(Number(price).toFixed(2)) * Number(Number(quantity).toFixed(2))
}

const onlyUnreadOptions = [
  { title: '有红点', value: true },
  // { title: '无红点', value: false }
]

// 日期筛选菜单状态
const dateFilterMenuOpen = ref(false)

// 搜索表单数据
const searchForm = reactive({
  keyword: '',
  fromDay: '',
  toDay: '',
  paymentType: null as number | null,
  onlyUnread: null as boolean | null
})

// 表格数据
const purchaseList = ref<PurchaseListItem[]>([])
const loading = ref(false)
const total = ref(0)
const currentPage = ref(1)
const pageSize = ref(30)

// 表格列配置
const headers = [
  { title: '采购单号', align: 'start', key: 'purchaseOrderNo', width: '70px' },
  { title: '供应商', align: 'start', key: 'supplierName', width: '190px' },
  { title: '付款公司', align: 'start', key: 'paymentCompany', width: '80px' },
  { title: '税率', align: 'center', key: 'taxRate', width: '55px' },
  { title: '税额', align: 'center', key: 'taxAmount', width: '85px' },
  { title: '合计金额', align: 'center', key: 'totalAmount', width: '90px' },
  { title: '含税总金额', align: 'center', key: 'totalAmountWithTax', width: '100px' },
  { title: '付款类型', align: 'center', key: 'paymentType', width: '90px' },
  { title: '采购标准', align: 'center', key: 'purchaseStandard', width: '180px' },
  { title: '送货地址', align: 'center', key: 'warehouseName', width: '120px' },
  { title: '下单人', align: 'center', key: 'createUserName', width: '65px' },
  { title: '已付', align: 'center', key: 'paidAmount', width: '90px' },
  { title: '操作', align: 'center', key: 'actions', width: '80px' }
]

// 添加格式化数字的函数
const formatNumber = (num: number) => {
  if(num){
    return num.toLocaleString('en-US')
  } else{
    return '0'
  }
}

// 格式化日期
const formatDate = (timestamp: number) => {
  if (!timestamp) return '/'
  const date = new Date(timestamp)
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).replace(/\//g, '/')
}

const formatNYDate = (timestamp: number) => {
  if (!timestamp) return ''
  const date = new Date(timestamp)
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).replace(/\//g, '/')
}

// 将日期字符串转换为时间戳（毫秒）
const dateTimestamp = (dateStr: string) => {
  if (!dateStr) return undefined
  try {
    const date = new Date(dateStr)
    date.setHours(0, 0, 0, 0)
    return date.getTime()
  } catch (error) {
    console.error('日期转换失败:', error)
    return undefined
  }
}

// 获取采购单列表
const loadPurchaseList = async () => {
  loading.value = true
  try {
    const params = {
      keyword: searchForm.keyword?.trim() || undefined,
      page: currentPage.value,
      pageSize: pageSize.value,
      fromTime: dateTimestamp(searchForm.fromDay),
      toTime: dateTimestamp(searchForm.toDay),
      // fromDay: searchForm.fromDay,
      // toDay: searchForm.toDay,
      onlyUnread: searchForm.onlyUnread,
      paymentType: searchForm.paymentType
    }
    
    const res = await purchaseApi.purchaseListAll(params)
    console.log('搜索响应数据:', res)
    
    if (res.code === 0) {
      purchaseList.value = res.data.records || []
      total.value = res.data.total || 0
      pageSize.value = res.data.size || 10
      currentPage.value = res.data.current || 1
    } else {
      console.error('API 返回错误:', res)
      purchaseList.value = []
      total.value = 0
    }
  } catch (error) {
    const err = error as Error
    console.error('获取采购单列表失败:', err.message)
    purchaseList.value = []
    total.value = 0
  } finally {
    loading.value = false
  }
}

// 搜索
const handleSearch = () => {
  console.log('触发搜索，当前搜索条件:', {
    keyword: searchForm.keyword?.trim()
  })
  currentPage.value = 1
  dateFilterMenuOpen.value = false
  loadPurchaseList()
}

// 重置
const handleReset = () => {
  console.log('触发重置')
  searchForm.keyword = ''
  searchForm.fromDay = ''
  searchForm.toDay = ''
  searchForm.onlyUnread = null
  searchForm.paymentType = null
  currentPage.value = 1
  loadPurchaseList()
}

// 计算总页数
const totalPages = computed(() => Math.ceil(total.value / pageSize.value))

// 处理页码变化
const changePage = (page: number) => {
  currentPage.value = page
  window.scrollTo(0, 0)
  loadPurchaseList()
}

// 处理每页条数变化
const handlePageSizeChange = (size: number) => {
  pageSize.value = size
  currentPage.value = 1 // 重置到第一页
  loadPurchaseList()
}

// 添加查看方法
const handleView = (item: PurchaseListItem) => {
  console.log('查看采购单:', item)
  let url = `/purchase/detail/${item.id}`
  window.open(url, '_blank')
  // router.push(`/purchase/detail/${item.id}`)
}

// 付款记录
const handlePaymentRecord = (item: PurchaseListItem, index: number) => {
  console.log('付款记录:', item)
  purchaseList.value[index].hasNewPaymentApply = false
  let url = `/purchase/detail/${item.id}/sign`
  window.open(url, '_blank')
}

// 页面加载时获取数据
onMounted(() => {
  loadPurchaseList()
})
</script>

<style scoped>
.purchase-page {
  min-height: 100vh;
  width: 100%;
  background-color: #2B2D33;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 16px;
}

.purchase-container {
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.search-card {
  background-color: #2B2D33 !important;
  border: none !important;

  :deep(.v-text-field),
  :deep(.v-autocomplete),
  :deep(.v-select) {
    .v-field__input,
    .v-field__field,
    input,
    .v-select__selection-text,
    .v-select__selection,
    .v-field__append-inner {
      color: #fff !important;
    }

    .v-field__outline {
      color: rgba(255, 255, 255, 0.12) !important;
    }

    .v-field__input::placeholder {
      color: rgba(255, 255, 255, 0.7) !important;
    }

    .v-label {
      color: rgba(255, 255, 255, 0.7) !important;
    }

    .v-field__append-inner i {
      color: rgba(255, 255, 255, 0.7) !important;
    }
  }
}

.table-card {
  background-color: #2B2D33 !important;
  flex: 1;
  display: flex;
  :deep(.v-card-text) {
    padding: 16px;
  }

  :deep(.v-col) {
    padding-top: 4px;
    padding-bottom: 4px;
    display: flex;
    justify-content: center;
  }

  .search-btn {
    font-weight: 400;
    text-transform: none;
    letter-spacing: 0;
    font-size: 14px;
    padding: 0 8px;
    min-width: unset;
  }
}

.table-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #2B2D33 !important;
  border-radius: 0;
  
  :deep(.v-card-text) {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

.purchase-table {
  flex: 1;
  background-color: #2B2D33 !important;
  color: #fff !important;
  border-radius: 0;
  
  :deep(th) {
    color: rgba(255, 255, 255, 0.7) !important;
    font-weight: 400;
    font-size: 14px;
    background-color: #2B2D33 !important;
    border-bottom: thin solid rgba(255, 255, 255, 0.12);
    padding: 0 0 0 8px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  :deep(td) {
    padding: 8px 0px 8px 8px !important;
    height: auto;
    min-height: 48px;
    color: #fff !important;
    border-bottom: thin solid rgba(255, 255, 255, 0.12) !important;
    white-space: normal;
    word-wrap: break-word;
    word-break: break-all;
  }
  
  :deep(tr:hover td) {
    background-color: rgba(255, 255, 255, 0.04) !important;
  }
}

.custom-pagination {
  background-color: rgba(255, 255, 255, 0.02);
  color: rgba(255, 255, 255, 0.7);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px;
  min-height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.items-per-page-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  user-select: none;
}

.pagination-info {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  user-select: none;
}

.pagination-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  min-width: 60px;
  text-align: center;
  user-select: none;
}

.page-size-select {
  padding: 0 !important;
  
  :deep(.v-field) {
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.1) !important;
    min-height: 32px !important;
    padding: 0 8px !important;
    background: transparent !important;
  }
  
  :deep(.v-field__input) {
    padding: 0 !important;
    min-height: 32px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 14px;
  }
  
  :deep(.v-select__selection) {
    color: rgba(255, 255, 255, 0.7) !important;
    margin: 0;
    padding: 0;
  }
  
  :deep(.v-field__append-inner) {
    padding-inline-start: 0;
    color: rgba(255, 255, 255, 0.7);
  }
  
  :deep(.v-field__outline) {
    display: none;
  }
  
  :deep(.v-input__control) {
    min-height: 32px !important;
    height: 32px !important;
  }
  
  :deep(.v-field--active),
  :deep(.v-field--dirty) {
    border-color: rgba(255, 255, 255, 0.2) !important;
  }
  
  :deep(.v-field--center-affix) .v-field__append-inner {
    align-items: center;
  }
}

/* 分页按钮样式 */
/* .pagination-btn {
  border-radius: 50% !important;
  min-width: 36px !important;
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
  margin: 0 4px !important;
  
  &:not(.v-btn--disabled) {
    background: linear-gradient(315deg, #E34C65, #D2475D) !important;
    color: white !important;
    border: none !important;
    box-shadow: 0 2px 8px rgba(227, 76, 101, 0.3) !important;

    &:hover {
      box-shadow: 0 4px 12px rgba(227, 76, 101, 0.4) !important;
    }
    
    &:active {
      box-shadow: 0 1px 4px rgba(227, 76, 101, 0.2) !important;
    }
  }
  
  &.v-btn--disabled {
    opacity: 0.5;
    background: linear-gradient(315deg, rgba(227, 76, 101, 0.5), rgba(255, 123, 142, 0.5)) !important;
    color: rgba(255, 255, 255, 0.5) !important;
    box-shadow: none !important;
  }
} */

:deep(.v-card) {
  box-shadow: none !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

:deep(.mdi-magnify::before){
  color: #fff!important;
}

:deep(.v-btn__underlay){
  background: none!important;
}

/* 采购弹窗样式 */
.purchase-dialog {
  background-color: #2B2D33 !important;
}

.purchase-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px 24px;
  font-size: 18px;
  font-weight: 500;
}

.purchase-dialog :deep(.v-card-text) {
  padding: 24px;
}

.purchase-dialog :deep(.v-card-actions) {
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.purchase-dialog :deep(.v-autocomplete .v-field__input),
.purchase-dialog :deep(.v-text-field .v-field__input),
.purchase-dialog :deep(.v-autocomplete input),
.purchase-dialog :deep(.v-text-field input) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__outline),
.purchase-dialog :deep(.v-text-field .v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__input::placeholder),
.purchase-dialog :deep(.v-text-field .v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.purchase-dialog :deep(.v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__append-inner i),
.purchase-dialog :deep(.v-text-field .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-list) {
  background-color: #2B2D33 !important;
}

.purchase-dialog :deep(.v-list-item) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item:hover) {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

.purchase-dialog :deep(.v-list-item-title) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.6) !important;
}

.purchase-dialog :deep(.v-messages__message) {
  color: #ff5252 !important;
}

/* 隐藏数字输入框的箭头 */
.purchase-dialog :deep(input[type="number"])::-webkit-inner-spin-button,
.purchase-dialog :deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.purchase-dialog :deep(input[type="number"]) {
  -moz-appearance: textfield;
}

.purchase-dialog :deep(.mdi) {
  color: #fff !important;
}

:deep(.v-field--readonly ) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

:deep(.v-field--readonly .v-field__input) {
  color: rgba(255, 255, 255, 0.5) !important;
}

:deep(.v-field--readonly),:deep(.v-field--readonly input),:deep(.v-field--readonly .v-select__selection-text){
  color: rgba(255, 255, 255, 0.7) !important;
}

.filter-menu {
  background-color: #2B2D33 !important;
}

.filter-menu :deep(.v-radio-group) {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-menu :deep(.v-radio) {
  min-height: 28px;
  padding: 0;
}

.filter-menu :deep(.v-radio .v-label) {
  font-size: 13px;
  opacity: 0.9;
}

.filter-menu :deep(.v-selection-control) {
  min-height: 28px;
}

.filter-menu :deep(.v-selection-control__wrapper) {
  width: 28px;
  height: 28px;
}

.filter-menu :deep(.v-radio-group .v-selection-control__input > i) {
  color: #D2475D !important;
  font-size: 16px;
}

.filter-menu :deep(.v-radio-group .v-selection-control--dirty .v-selection-control__input > i) {
  opacity: 1;
}

.filter-menu :deep(.v-card-text.pa-2) {
  background-color: #fff !important;
  width: 100px;
}

/* 日期筛选菜单样式 */
.date-filter-menu {
  min-width: 280px !important;
  background-color: #2B2D33 !important;
}

.date-filter-menu :deep(.v-card-text) {
  background-color: #2B2D33 !important;
}

.date-filter-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.date-field-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.date-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.date-picker-container {
  position: relative;
}

.native-date-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}

.native-date-input::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  cursor: pointer;
}

.date-input-field :deep(.v-field) {
  background-color: rgba(255, 255, 255, 0.05) !important;
  cursor: pointer !important;
}

.date-input-field :deep(.v-field__input) {
  color: #fff !important;
  cursor: pointer !important;
}

.date-input-field :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.date-input-field :deep(.v-field__input input::placeholder) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.date-input-field :deep(.mdi) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.date-filter-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 4px;
}

.text-primary {
  color: #D2475D !important;
}

.payment-type{
  width: 50px;
  padding: 4px 0px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid #FFFFFF;
  font-weight: 400;
  color: #E8E8E8;
  text-align: center;
  font-style: normal;
  text-transform: none;
  display: inline-block;
}
</style> 